/**
 * RTK Query API for the support domain — the contact form.
 *
 * Contact-form-only, same as mobile's supportApi: the support-chat
 * endpoints (get-or-create conversation, send, unread badge) live in
 * conversationApi, where support chat reads its messages through the
 * shared getMessages endpoint + socket cache listener. This slice used
 * to carry those endpoints plus a DUPLICATE messages query reaching the
 * conversations endpoint via a `/../conversations/` path hack — both
 * moved/died in the 2026-08-06 consolidation.
 */
import { createApi } from "@reduxjs/toolkit/query/react";
import { SUPPORT_ROUTES, type ContactUsRequest } from "@gearghost/api-schemas/support";
import {
  MessageOnlyEnvelopeSchema,
  type MessageOnlyEnvelope as MessageOnly,
} from "@gearghost/api-schemas/auth";
import axiosBaseQuery from "./axiosBaseQuery";
import { onSchemaFailure } from "./onSchemaFailure";

export const supportApi = createApi({
  reducerPath: "supportApi",
  baseQuery: axiosBaseQuery(),
  onSchemaFailure,
  endpoints: (builder) => ({
    // Submit the contact form. Body contract is shared with the backend
    // validator; the response is message-only (201).
    createContactUs: builder.mutation<MessageOnly, ContactUsRequest>({
      query: (body) => ({
        url: SUPPORT_ROUTES.contactus,
        method: "POST",
        body,
      }),
      rawResponseSchema: MessageOnlyEnvelopeSchema,
      responseSchema: MessageOnlyEnvelopeSchema,
    }),
  }),
});

export const { useCreateContactUsMutation } = supportApi;
